
const config = {
    host: '',
    imgHost: location.origin + '/'
}

export default config;